import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip,{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.getReleaseStatusDisplayHtml(_vm.softwareOffer.releaseStatus)),expression:"getReleaseStatusDisplayHtml(softwareOffer.releaseStatus)"}],attrs:{"small":"","outlined":"","color":_vm.getReleaseStatusColor(_vm.softwareOffer.releaseStatus)}})
}
var staticRenderFns = []

export { render, staticRenderFns }